"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCategoryGroupListsFailureAction = exports.createCategoryGroupListsSuccessAction = exports.createCategoryGroupListsAction = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const actionHelpers_1 = require("companion-app-components/flux/core/actionHelpers");
const errorPayloadCreator = (0, actionHelpers_1.getPayloadCreator)();
const categoryGroupsPayloadCreator = (0, actionHelpers_1.getPayloadCreator)();
exports.createCategoryGroupListsAction = (0, toolkit_1.createAction)('CREATE_CATEGORY_GROUP_LISTS', categoryGroupsPayloadCreator);
exports.createCategoryGroupListsSuccessAction = (0, toolkit_1.createAction)('CREATE_CATEGORY_GROUP_LISTS_SUCCESS', categoryGroupsPayloadCreator);
exports.createCategoryGroupListsFailureAction = (0, toolkit_1.createAction)('CREATE_CATEGORY_GROUP_LISTS_FAILURE', errorPayloadCreator);
